import { useEffect } from "react"
import { useDispatch } from "react-redux"

import { getInbox } from "../Actions/API/Inbox/InboxActions"
import { InboxState } from "../Reducers/API/Inbox/InboxReducer"
import { useAppState } from "./useReduxState"

export function useInbox(appID?: string): InboxState {
    const dispatch = useDispatch()
    const inboxState = useAppState(state => state.api.inbox)

    useEffect(() => {
        if (appID === undefined) {
            return
        }

        dispatch(getInbox(appID))
    }, [appID, dispatch])

    return inboxState
}
